import { useState } from 'react';
import Sidebar from '../components/Sidebar';

interface Request {
  id: number;
  plannerName: string;
  plannerCompany: string;
  customerName: string;
  requestDate: string;
  shootingDate: string;
  shootingType: string;
  location: string;
  status: string;
  memo: string;
  createdAt: string;
}

export default function StudioRequestsPage() {
  const [statusFilter, setStatusFilter] = useState('전체');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState<Request | null>(null);

  const requests: Request[] = [
    {
      id: 1,
      plannerName: '김플래너',
      plannerCompany: '드림웨딩',
      customerName: '이지은',
      requestDate: '2024-01-20',
      shootingDate: '2024-02-15',
      shootingType: '본식스냅',
      location: '그랜드웨딩홀',
      status: '승인대기',
      memo: '영상 동시 촬영 가능 여부 확인 필요',
      createdAt: '2024-01-20 14:30'
    },
    {
      id: 2,
      plannerName: '박플래너',
      plannerCompany: '로맨틱웨딩',
      customerName: '김민수',
      requestDate: '2024-01-22',
      shootingDate: '2024-02-20',
      shootingType: '리허설',
      location: '스튜디오 A',
      status: '승인완료',
      memo: '야외 촬영 포함',
      createdAt: '2024-01-22 10:15'
    },
    {
      id: 3,
      plannerName: '최플래너',
      plannerCompany: '프리미엄웨딩',
      customerName: '박영희',
      requestDate: '2024-01-23',
      shootingDate: '2024-03-01',
      shootingType: '스냅+영상',
      location: '로얄웨딩홀',
      status: '승인대기',
      memo: '드론 촬영 요청',
      createdAt: '2024-01-23 16:45'
    },
    {
      id: 4,
      plannerName: '이플래너',
      plannerCompany: '엘리트웨딩',
      customerName: '최수진',
      requestDate: '2024-01-18',
      shootingDate: '2024-02-10',
      shootingType: '본식영상',
      location: '파라다이스웨딩홀',
      status: '거절',
      memo: '일정 중복으로 거절',
      createdAt: '2024-01-18 11:20'
    }
  ];

  const filteredRequests = requests.filter(request => 
    statusFilter === '전체' || request.status === statusFilter
  );

  const statusOptions = ['전체', '승인대기', '승인완료', '거절'];

  const handleApprove = (request: Request) => {
    alert(`${request.customerName} 님의 촬영 요청이 승인되었습니다.`);
    setShowDetailModal(false);
  };

  const handleReject = (request: Request) => {
    const reason = prompt('거절 사유를 입력하세요:');
    if (reason) {
      alert(`${request.customerName} 님의 촬영 요청이 거절되었습니다.`);
      setShowDetailModal(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">플래너 협업 관리</h1>
          <p className="text-sm text-gray-600 mt-1">플래너의 촬영 요청을 확인하고 승인하세요</p>
        </div>

        {/* 통계 카드 */}
        <div className="grid grid-cols-4 gap-6 mb-6">
          <div className="bg-white rounded-lg shadow-sm p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">전체 요청</p>
                <p className="text-2xl font-bold text-gray-800">{requests.length}건</p>
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <i className="ri-file-list-line text-xl text-blue-600"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">승인 대기</p>
                <p className="text-2xl font-bold text-orange-600">
                  {requests.filter(r => r.status === '승인대기').length}건
                </p>
              </div>
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                <i className="ri-time-line text-xl text-orange-600"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">승인 완료</p>
                <p className="text-2xl font-bold text-green-600">
                  {requests.filter(r => r.status === '승인완료').length}건
                </p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <i className="ri-check-line text-xl text-green-600"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">거절</p>
                <p className="text-2xl font-bold text-red-600">
                  {requests.filter(r => r.status === '거절').length}건
                </p>
              </div>
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                <i className="ri-close-line text-xl text-red-600"></i>
              </div>
            </div>
          </div>
        </div>

        {/* 필터 */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex gap-2">
            {statusOptions.map((status) => (
              <button
                key={status}
                onClick={() => setStatusFilter(status)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  statusFilter === status
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {status}
              </button>
            ))}
          </div>
        </div>

        {/* 요청 목록 */}
        <div className="space-y-4">
          {filteredRequests.map((request) => (
            <div 
              key={request.id} 
              className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
                    <i className="ri-user-star-line text-2xl text-purple-600"></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <h3 className="text-xl font-bold text-gray-800">{request.customerName}</h3>
                      <span className={`inline-flex px-3 py-1 text-xs font-medium rounded-full ${
                        request.status === '승인완료' ? 'bg-green-100 text-green-700' :
                        request.status === '승인대기' ? 'bg-orange-100 text-orange-700' :
                        'bg-red-100 text-red-700'
                      }`}>
                        {request.status}
                      </span>
                      <span className="inline-flex px-3 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-700">
                        {request.shootingType}
                      </span>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-gray-600">
                      <div className="flex items-center gap-1">
                        <i className="ri-building-line w-4 h-4 flex items-center justify-center"></i>
                        <span>{request.plannerCompany} - {request.plannerName}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                        <span>촬영일: {request.shootingDate}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                        <span>{request.location}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 mb-4">
                <div className="text-sm text-gray-600 mb-1">요청 메모</div>
                <div className="text-sm text-gray-800">{request.memo}</div>
              </div>

              <div className="flex items-center justify-between text-sm text-gray-500">
                <div>요청일시: {request.createdAt}</div>
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      setSelectedRequest(request);
                      setShowDetailModal(true);
                    }}
                    className="text-blue-600 hover:text-blue-800 px-3 py-1.5 hover:bg-blue-50 rounded transition-colors cursor-pointer font-medium"
                  >
                    상세보기
                  </button>
                  {request.status === '승인대기' && (
                    <>
                      <button
                        onClick={() => handleApprove(request)}
                        className="text-green-600 hover:text-green-800 px-3 py-1.5 hover:bg-green-50 rounded transition-colors cursor-pointer font-medium"
                      >
                        승인
                      </button>
                      <button
                        onClick={() => handleReject(request)}
                        className="text-red-600 hover:text-red-800 px-3 py-1.5 hover:bg-red-50 rounded transition-colors cursor-pointer font-medium"
                      >
                        거절
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredRequests.length === 0 && (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <i className="ri-inbox-line text-4xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">요청이 없습니다.</p>
          </div>
        )}
      </div>

      {/* 상세보기 모달 */}
      {showDetailModal && selectedRequest && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">촬영 요청 상세</h2>
              <button
                onClick={() => setShowDetailModal(false)}
                className="text-gray-500 hover:text-gray-700 w-6 h-6 flex items-center justify-center cursor-pointer"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>

            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-600 mb-1">플래너 회사</label>
                  <div className="px-3 py-2 bg-gray-50 rounded-lg">{selectedRequest.plannerCompany}</div>
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">플래너명</label>
                  <div className="px-3 py-2 bg-gray-50 rounded-lg">{selectedRequest.plannerName}</div>
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">고객명</label>
                  <div className="px-3 py-2 bg-gray-50 rounded-lg">{selectedRequest.customerName}</div>
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">촬영 유형</label>
                  <div className="px-3 py-2 bg-gray-50 rounded-lg">{selectedRequest.shootingType}</div>
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">촬영일</label>
                  <div className="px-3 py-2 bg-gray-50 rounded-lg">{selectedRequest.shootingDate}</div>
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">촬영 장소</label>
                  <div className="px-3 py-2 bg-gray-50 rounded-lg">{selectedRequest.location}</div>
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">요청 메모</label>
                <div className="px-3 py-2 bg-gray-50 rounded-lg">{selectedRequest.memo}</div>
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">상태</label>
                <div className={`inline-flex px-3 py-1 text-sm font-medium rounded-full ${
                  selectedRequest.status === '승인완료' ? 'bg-green-100 text-green-700' :
                  selectedRequest.status === '승인대기' ? 'bg-orange-100 text-orange-700' :
                  'bg-red-100 text-red-700'
                }`}>
                  {selectedRequest.status}
                </div>
              </div>
            </div>

            {selectedRequest.status === '승인대기' && (
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => handleReject(selectedRequest)}
                  className="px-6 py-2 text-red-600 border border-red-300 rounded-lg hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  거절
                </button>
                <button
                  onClick={() => handleApprove(selectedRequest)}
                  className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  승인
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}